import { useEffect, useState } from 'react';
import { formData, responseData, CheckDACH, setErrorReceived, ErrorMessage, getErrorMessage } from '../../utils/data';
import AddressTable from '../tables/addressTable';
import AliasTable from '../tables/aliasTable';
import MedicalCertTable from '../tables/medcertTable';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import PrintPage from '../PrintPage';
import { useAuth } from '../../context/AuthContext';
import RestrictionTable from '../tables/restrictionsTable';
import EndorsementsTable from '../tables/endorsementsTable';
import HazmatTable from '../tables/hazmatTable';
import PermitTables from '../tables/permitTable';
import { createLog } from '../datawriter/createLog';
import "../print.css"

function StatusResponse() {
    // const testData = api.statusResponse;
    const [testData, setTestData] = useState({});
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState([]);
    const [requestID, setRequestID ]= useState();
    const navigate = useNavigate();
    const { token, email } = useAuth();    
    //createLog("", email);
    useEffect(() => {
        const fetchData = async () => {
          try {
            await responseData('/api/status', token)
            .then(function (response) {
                console.log("response received from status request", response);
                setTestData(response);
                createLog(response, email);
                setErrorMessage(response.Messages);
                if(response?.Response?.DriverDetails !== undefined) {
                    setRequestID(response.TransactionGUID);
                    setLoading(false);
                } else {
                    setErrorReceived(response?.Messages?.length > 0 ? response.Messages : ["Database Unavailable"]);
                    navigate(-1);
                }
            })
            .catch(  (error) => {
                console.error(error);
                setErrorReceived([getErrorMessage(error, 'Unable to retrieve status information. Please try again.')]);
                navigate(-1);
            })
            
          } catch (error) {
            console.error('caught error: ', error);
            setErrorReceived([getErrorMessage(error, 'Unable to retrieve status information. Please try again.')]);
            navigate(-1);
          }
          
        };
        fetchData();
    }, []);
    console.log(errorMessage)
    if(loading){
        return(<>
        <Loading />
        </>)
    }
    return(
        <> 
        <div id='print-area'>
        <CheckDACH dach={testData.Response.DACH_Status}/>
        {errorMessage.map((message => (
            <ErrorMessage value={message} />
        )))}
            <div className="table-responsive-sm" id='table'>
            <div style={{ fontSize:'small', width: 'fit-content', background: 'white'}}>
                <div id="banner-results">
                    
                        <h4>Status Search Results</h4>
                        
                        <h6>
                        <span>/{formData.Body.DriverRequest.DriverLicense.LicenseState}/{formData.Body.DriverRequest.DriverLicense.LicenseNumber}</span>
                        <span style={{float: 'right' }}>{requestID}</span>
                    </h6>
                    
                
                </div><th>Driver General Information</th>
                <table className="table table-striped table-bordered">
                
                <thead style={{width: '100%'}}>
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Middle Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.FirstName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.MiddleName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.SurName}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PersonName.Suffix}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">SSN</th>
                        <th scope="col">Date of Birth</th>
                        <th scope="col">Height</th>
                        <th scope="col">Weight</th>
                        <th scope="col">Eye Color</th>
                        <th scope="col">Sex</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{testData.Response.DriverDetails.PersonDetails.SSN}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.DOB}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Height}</td>
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Weight}</td>
                        {testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1] ? <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor.split('-')[1]}</td>: <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.EyeColor}</td>}
                        <td>{testData.Response.DriverDetails.PersonDetails.PhysicalDetails.Sex}</td>
                    </tr>
                </tbody>
            </table>
                <div>
                    <AddressTable label="Residence Address" address={testData.Response.DriverDetails.PersonDetails.ResidenceAddress}/>
                    <AddressTable label="Mailing Address" address={testData.Response.DriverDetails.PersonDetails.MailingAddress}/>
                    <AliasTable alias={testData.Response.DriverDetails.Alias}/>
                </div>
                <th>Driver License Details</th>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Jurisdiction</th>
                            <th scope="col">Driver License</th>
                            <th scope="col">Issue Date</th>
                            <th scope="col">Expiration Date</th>
                            <th scope="col">Commercial Class</th>
                            <th scope="col">Commercial Status</th>
                            <th scope="col">Non Commercial Class</th>
                            <th scope="col">Non Commercial Status</th>
                            <th scope="col">Withdrawal Action Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{testData.Response.DriverDetails.License.JurisdictionOfIssue}</td>
                            <td>{testData.Response.DriverDetails.License.LicenseNumber}</td>
                            <td>{testData.Response.DriverDetails.License.IssueDate}</td>
                            <td>{testData.Response.DriverDetails.License.ExpirationDate}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.CommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialClassCode}</td>
                            <td>{testData.Response.DriverDetails.License.NonCommercialStatus.split('-')[1]}</td>
                            <td>{testData.Response.DriverDetails.License.WithdrawalActionPending.split('-')[1]}</td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <EndorsementsTable endorsements={testData.Response.DriverDetails.Endorsements}/>
                    <HazmatTable hazmat={testData.Response.DriverDetails.HazMatEndorsement}/>
                    <MedicalCertTable medCert={testData.Response.DriverDetails.MedicalCertificate}
                    medName={testData.Response.DriverDetails.MedicalExaminerName}
                    med={testData.Response.DriverDetails.MedicalExaminer}
                    medRest={testData.Response.DriverDetails.MedicalCertificateRestrictionCode}/>
                    <RestrictionTable restrictions={testData.Response.DriverDetails.Restrictions}/>
                    <PermitTables permits={testData.Response.DriverDetails.Permits}/>
                    
                </div>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th scope="col">Convictions</th>
                        <th scope="col">Accidents</th>
                        <th scope="col">Withdrawals</th>
                        <th scope="col">Permits</th>
                        <th scope="col">License Restrictions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    {testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord ? <td>{testData.Response.DriverDetails.License.Total_ACD_ConvictionsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.TotalAccidentsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalAccidentsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord ? <td>{testData.Response.DriverDetails.License.TotalWithdrawalsOnRecord}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.NumberOfPermits ? <td>{testData.Response.DriverDetails.License.NumberOfPermits}</td> : <td>0</td>}
                        {testData.Response.DriverDetails.License.NumberOfRestrictions ? <td>{testData.Response.DriverDetails.License.NumberOfRestrictions}</td> : <td>0</td>}
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a href='/'><button type="button" class="btn btn-primary" id="button">Done</button></a>
            <PrintPage
            type="status"
            response={testData.Response}
            queryLine={`/${formData.Body.DriverRequest.DriverLicense.LicenseState}/${formData.Body.DriverRequest.DriverLicense.LicenseNumber}`}
            transactionID={requestID}
            messages={errorMessage}
            />

         </div>
         </div></>
    );
}
export default StatusResponse;